import AppLayout from '@/layout/AppLayout.vue'

const IpoSubscription = () => import('@/view/ipo/IpoSubscription.vue')

const routes = [
  {
    component: AppLayout,
    children: [
      {
        path: '/ipo',
        component: IpoSubscription,
        meta: { key: 'ipo', header: 'coinStock' },
      },
      {
        path: '/ipo/subscription',
        component: IpoSubscription,
        meta: { key: 'ipo', header: 'coinStock' },
      },
    ],
  },
]

const components = {}

export default {
  routes,
  components,
}
